export default "__VITE_ASSET__DNN8sujl__";